export const TAG_OPTIONS = {
  untrusted: {
    name: 'untrusted',
    label: 'Untrusted'
  },
  trusted: {
    name: 'trusted',
    label: 'Trusted'
  },
  universal: {
    name: 'universal',
    label: 'Universal'
  }
}
